export const mobilityInfo = [
  {
    title: 'Agilize sua vistoria',
    description:
      'O sistema de machine learning oferece sugestões inteligentes de preenchimento automático de acordo com o seu uso.'
  },
  {
    title: 'Use com facilidade',
    description:
      'Nosso design é moderno e intuitivo, pensado na sua usabilidade, para que qualquer pessoa consiga usar o aplicativo.'
  },
  {
    title: 'Trabalhe com liberdade',
    description:
      'As vistorias de imóveis podem ser feitas offline, precisando de conexão somente na hora de integrar com o sistema de gestão.'
  }
]
